interface GeocodeResult {
  zipCode: string | null;
  latitude: string | null;
  longitude: string | null;
  error?: string;
}

/**
 * Fetches geocode data from OpenStreetMap Nominatim API
 * @param address - Full address string to geocode
 * @returns Promise<GeocodeResult>
 */
const fetchGeocode = async (address: string): Promise<GeocodeResult> => {
    console.log(address,'address')
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`,
      {
        headers: {
          'User-Agent': 'Gwarm/1.0 (zeya@gwarm.net)' // Required by Nominatim
        }
      }
    );

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    
    if (!data || data.length === 0) {
      return { 
        zipCode: null, 
        latitude: null, 
        longitude: null,
        error: "No results found" 
      };
    }

    const firstResult = data[0];
    return {
      zipCode: firstResult.address?.postcode || null,
      latitude: firstResult.lat,
      longitude: firstResult.lon
    };
    
  } catch (error) {
    console.error("Geocoding failed:", error);
    return {
      zipCode: null,
      latitude: null,
      longitude: null,
      error: error instanceof Error ? error.message : "Geocoding failed"
    };
  }
};

// Usage Example
export const populateSenderData = async (sender: any) => {
  const fullAddress = `${sender?.address}, ${sender?.districtName}, ${sender?.cityName}, ${sender?.countryName}`;
  
  const { zipCode, latitude, longitude, error } = await fetchGeocode(fullAddress);

  if (error) {
    console.warn("Using fallback ZIP code for Mansarovar");
    return {
      ...sender,
      zipCode: "302020", // Fallback for Mansarovar
      latitude: latitude || "26.8636", // Fallback coordinates
      longitude: longitude || "75.7877"
    };
  }

  return {
    ...sender,
    zipCode,
    latitude,
    longitude
  };
};